/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleCategoryDto } from '../../models/article-category-dto';
import { ArticleCategoryWithIdDto } from '../../models/article-category-with-id-dto';

export interface ShopInsertArticleCategory$Params {
  'x-trace-id'?: string;
      body: ArticleCategoryDto
}

export function shopInsertArticleCategory(http: HttpClient, rootUrl: string, params: ShopInsertArticleCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCategoryWithIdDto>> {
  const rb = new RequestBuilder(rootUrl, shopInsertArticleCategory.PATH, 'post');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleCategoryWithIdDto>;
    })
  );
}

shopInsertArticleCategory.PATH = '/api/shop/category';
